import React from 'react';
import {
    makeStyles,
    Switch,
    FormControlLabel,
    Button,
    Paper,
    TextField,
    InputAdornment,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';

const useStyles = makeStyles(theme => ({
    toolbar: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        padding: 16,
        marginBottom: 8,
        border: `1px solid ${theme.palette.divider}`,
    },
    search: {
        flexGrow: 1,
        minWidth: 240,
        maxWidth: 420,
        marginRight: 24,
    },
    toggle: {
        marginRight: 24,
    },
    spacer: {
        flexGrow: 1,
    },
}));

const ProductsToolbar = ({
    term,
    onTermChange,
    onlyMoneyProducts,
    onOnlyMoneyProductsChange,
    cashbackFactor,
    onCashbackClick,
}) => {
    const classes = useStyles();

    return (
        <Paper className={classes.toolbar} elevation={0}>
            <TextField
                className={classes.search}
                variant="outlined"
                size="small"
                placeholder="Buscar produto"
                value={term}
                onChange={event => onTermChange(event.target.value)}
                autoFocus
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon fontSize="small" color="disabled" />
                        </InputAdornment>
                    ),
                }}
            />
            <FormControlLabel
                className={classes.toggle}
                label="Produtos em dinheiro"
                control={
                    <Switch
                        color="primary"
                        onChange={event => onOnlyMoneyProductsChange(event.target.checked)}
                        checked={onlyMoneyProducts} />
                } />
            <div className={classes.spacer} />
            {cashbackFactor > 0 && (
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AccountBalanceWalletOutlinedIcon />}
                    onClick={() => onCashbackClick(true)}>
                    Resgatar cashback
                </Button>
            )}
        </Paper>
    );
};

export default ProductsToolbar;
